import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './AnimalProduction.css';
import { HiArrowLongLeft } from "react-icons/hi2";
import { useNavigate } from 'react-router-dom';
import logo_footer_color from '../../assets/logos_footer_color.svg';
import logo_agroinsider_color from '../../assets/logo-agroinsider-color.svg';
import img_animal_production from '../../assets/producao_animal_inicio.svg';
import cattle_production_icon from '../../assets/bovinos_carne.svg';
import cattle_milk_production_icon from '../../assets/bovinos_leite.svg';
import sheep_production_icon from '../../assets/ovinos.svg';
import goat_production_icon from '../../assets/caprinos.svg';
import pigs_production_icon from '../../assets/suinos.svg';
import horse_production_icon from '../../assets/equinos.svg';
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';

const AnimalProduction = ({ animalProduction, setAnimalProduction, farmType }) => {
  const [formData, setFormData] = useState(animalProduction);
  const { t } = useTranslation();
  const navigate = useNavigate(); // Para navegação programática

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleNavigateBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setAnimalProduction(formData);
    navigate('/fuel-spent');
  };

  const handleCheckboxChange = (event) => {
    const { name, value } = event.target;
    if (value && value.length > 0) {
      const numericValue = Math.max(0, Number(value)); // Garante que o valor seja >= 0

      if (numericValue) {
        setFormData((prevState) => ({
          ...prevState,
          [name]: numericValue,
        }));
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: 0,
      }));
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className='form-background'>
        <div className='div-agroinsider-logo'>
          <img src={logo_agroinsider_color} alt="AgroInsider Logo" className="logo" />
        </div>
        <div className='div-page-logo'>
          <img className='img-page-logo' src={img_animal_production} alt="AgroInsider Logo" />
        </div>
        <div className='farm-profile-description'>
          <span className='farm-profile-title'>{t('AnimalProduction.title')}</span>
          <p className='farm-profile-description-text'>{t('AnimalProduction.description')}</p>
        </div>

        <div className="form-profile-form">
          <div className="form-group">
            <div className="nested-checkboxes">
              <div className='grid-container' style={{ padding: "0px 0px 10px 0px", marginTop: "10px" }}>
                <div className='grid-item'>
                  <img alt='icon' src={cattle_production_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <span>{t('AnimalProduction.spicesOption1')}</span>
                </div>
                <div className='grid-item'>
                  <input
                    placeholder='0'
                    className='input-animalProdution'
                    type="input"
                    name="cattle"
                    checked={formData.cattle}
                    onChange={(e) => handleCheckboxChange(e)}
                    value={formData.cattle}
                  />
                </div>
              </div>
              <hr></hr>
              <div className='grid-container' style={{ padding: "0px 0px 10px 0px", marginTop: "10px" }}>
                <div className='grid-item'>
                  <img alt='icon' src={cattle_milk_production_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <span>{t('AnimalProduction.spicesOption2')}</span>
                </div>
                <div className='grid-item'>
                  <input
                    placeholder='0'
                    className='input-animalProdution'
                    type="input"
                    name="cattle_milk"
                    checked={formData.cattle_milk}
                    onChange={(e) => handleCheckboxChange(e)}
                    value={formData.cattle_milk}
                  />
                </div>
              </div>
              <hr></hr>
              <div className='grid-container' style={{ padding: "0px 0px 10px 0px", marginTop: "10px" }}>
                <div className='grid-item'>
                  <img alt='icon' src={sheep_production_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <span>{t('AnimalProduction.spicesOption3')}</span>
                </div>
                <div className='grid-item'>
                  <input
                    placeholder='0'
                    className='input-animalProdution'
                    type="input"
                    name="sheep"
                    checked={formData.sheep}
                    onChange={(e) => handleCheckboxChange(e)}
                    value={formData.sheep}
                  />
                </div>
              </div>
              <hr></hr>
              <div className='grid-container' style={{ padding: "0px 0px 10px 0px", marginTop: "10px" }}>
                <div className='grid-item'>
                  <img alt='icon' src={goat_production_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <span>{t('AnimalProduction.spicesOption4')}</span>
                </div>
                <div className='grid-item'>
                  <input
                    placeholder='0'
                    className='input-animalProdution'
                    type="input"
                    name="birds"
                    checked={formData.birds}
                    onChange={(e) => handleCheckboxChange(e)}
                    value={formData.birds}
                  />
                </div>
              </div>
              <hr></hr>
              <div className='grid-container' style={{ padding: "0px 0px 10px 0px", marginTop: "10px" }}>
                <div className='grid-item'>
                  <img alt='icon' src={pigs_production_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <span>{t('AnimalProduction.spicesOption5')}</span>
                </div>
                <div className='grid-item'>
                  <input
                    placeholder='0'
                    className='input-animalProdution'
                    type="input"
                    name="rabbits"
                    checked={formData.rabbits}
                    onChange={(e) => handleCheckboxChange(e)}
                    value={formData.rabbits}
                  />
                </div>
              </div>
              <hr></hr>
              <div className='grid-container' style={{ padding: "0px 0px 10px 0px", marginTop: "10px" }}>
                <div className='grid-item'>
                  <img alt='icon' src={horse_production_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <span>{t('AnimalProduction.spicesOption6')}</span>
                </div>
                <div className='grid-item'>
                  <input
                    placeholder='0'
                    className='input-animalProdution'
                    type="input"
                    name="horses"
                    checked={formData.horses}
                    onChange={(e) => handleCheckboxChange(e)}
                    value={formData.horses}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='form-group-bottom-buttons'>
          <div className="form-group-buttons">
            <button className='form-back-button' onClick={() => handleNavigateBack()}>
              <HiArrowLongLeft size={28} />
            </button>
            <button className="form-next-button" type="submit">{t('AnimalProduction.submit')}</button>
          </div>
        </div>
        <LanguageSwitcher />
        <div className='div-logo-footer-color'>
          <img src={logo_footer_color} alt="AgroInsider Logo" className="logo" />
        </div>
      </div>
    </form>
  );
}

export default AnimalProduction;
